import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import { popUpBody, popUpContent, popUpHeader } from "./PopUp.styled";
import SubHeading from "../Text/subHeading";
import Heading from "../Text/heading";

const PopUp = ({ popUpMessage, isOpen, onClose, popUpHeading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent {...popUpContent}>
        <Heading {...popUpHeader} headingLabel={popUpHeading}></Heading>
        <ModalCloseButton />
        <ModalBody>
          <SubHeading
            {...popUpBody}
            subHeadingLabel={popUpMessage}
          ></SubHeading>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PopUp;
